import React from 'react';
import { Box, Paper } from '@mui/material';
import SelectionGroup from './SelectionGroup';

const SelectionStep = ({ step, selectionData, onChange, errors }) => {
  const groups = [...(step.selectionGroups || [])].sort((a, b) => a.order - b.order);

  return (
    <Box elevation={0} sx={{ p: 0, borderRadius: 0, bgcolor: 'transparent' }}>
      <Box>
        {groups.map((group) => (
          <SelectionGroup
            key={group.id}
            group={group}
            value={selectionData[group.id]}
            onChange={onChange}
            error={errors[group.id]}
          />
        ))}
      </Box>
    </Box>
  );
};

export default SelectionStep;
